import dom from './dom'
import toast from './toast'
import loading from './loading'

export default {
  dom,
  toast,
  loading
}
